<template>

    <bottom-sheet ref="bottomsheet">

        <div v-if="askPermission" class="bsfn__container">

            <img class="bsfn__img" src="/img/bottomsheet/illustration-phone-push.svg">

            <h1 class="bsfn__title">{{ $t('fetch_bottom_sheet_title') }}</h1>

            <p class="bsfn__subtitle">{{ $t('fetch_bottom_sheet_description') }}</p>

            <button class="btn btn-blue bsfn__btn-accept" @click="accept">
                <span v-show="!loading">{{ $t('fetch_bottom_sheet_cta_ok') }}</span>
                <lottie-loader v-show="loading" :size="24"></lottie-loader>
            </button>

            <button class="btn btn-white bsfn__btn-cancel" @click="close">{{ $t('fetch_bottom_sheet_cta_no') }}</button>

        </div>

    </bottom-sheet>

</template>

<script>

import Notifs from '@/modules/notifications'

import BottomSheet from '@/components/bottomSheet/BottomSheet'
import LottieLoader from '@/components/lottie/LottieLoader'

export default {

    name: 'bottom-sheet-fetch-notifications',

    components: {BottomSheet, LottieLoader},

    data() {
        return {
            show: false,
            askPermission: true,
            loading: false
        }
    },

    methods: {

        open() {
            this.$refs.bottomsheet.open()
        },

        close() {
            this.$refs.bottomsheet.close()
            this.$emit('close')
        },

        accept() {

            this.loading = true
            Notifs.update({important: true, news: true})
                .catch(() => {
                })
                .finally(() => {

                    this.$emit('permissionResponse', Notifs.permission())
                    this.loading = false
                    this.close()
                })

        },

        cancel() {
            this.close()
        }
    }

}

</script>

<style lang="scss" scoped>

.bsfn {
    &__container {
        width: 100%;
        padding: 64px 25px 120px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        color: $midnight;
        text-align: left;
        background-image: url('/img/bottomsheet/background-wood-mobile.svg');
        background-repeat: no-repeat;
        background-position-x: right;
        background-position-y: bottom;
        background-size: auto;
        @media screen and (min-width: $above-tablet-length) {
            background-image: url('/img/bottomsheet/background-wood-mobile.svg');
            padding: 80px 24px;
        }
    }

    &__img {
        width: 72px;
        object-fit: contain;
    }

    &__title {
        margin-top: 32px;
        font-size: 28px;
        font-weight: bold;
    }

    &__subtitle {
        margin-top: 14px;
        font-size: 17px;
        line-height: 1.29;
    }

    &__btn-accept {
        margin-top: 24px;
        height: 51px;
        width: initial;
        padding: 0 24px;
        font-size: 16px;
    }

    &__btn-cancel {
        margin-top: 16px;
        height: 51px;
        width: initial;
        padding: 0 24px;
        font-size: 16px;
        color: $blue;
        border: 2px solid $blue;
    }
}

</style>
